import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '@tark/shared/lib';

type AppPageFrameProps = ComponentPropsWithoutRef<'div'> & {
  width?: 'full' | 'bounded';
};

export function AppPageFrame({
  className,
  width = 'full',
  ...props
}: AppPageFrameProps) {
  return (
    <div
      data-layout="app-page"
      className={cn(
        'w-full pb-24 md:pb-8',
        width === 'bounded' ? 'max-w-7xl' : 'max-w-none',
        className
      )}
      {...props}
    />
  );
}
